import { useState, useEffect } from 'react';

const STORAGE_KEY = 'vanta-theme';

export function getSystemTheme() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function getTheme() {
  try {
    return localStorage.getItem(STORAGE_KEY) || getSystemTheme();
  } catch {
    return getSystemTheme();
  }
}

function applyTheme(theme) {
  document.documentElement.dataset.theme = theme;
}

export function setTheme(theme) {
  try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* private browsing, etc. */ }
  applyTheme(theme);
  window.dispatchEvent(new CustomEvent('vanta-themechange', { detail: theme }));
}

export function initTheme() {
  applyTheme(getTheme());
}

export function useTheme() {
  const [theme, setThemeState] = useState(getTheme());
  useEffect(() => {
    const handler = e => setThemeState(e.detail);
    window.addEventListener('vanta-themechange', handler);
    return () => window.removeEventListener('vanta-themechange', handler);
  }, []);
  const toggleTheme = () => setTheme(theme === 'dark' ? 'light' : 'dark');
  return [theme, toggleTheme];
}
